module.exports = __webpack_public_path__ + "static/img/st4.f28578ee.png";